export default {
  badge: 'Знак',
  open: 'Открыть',
  close: 'Закрыть',
  dismiss: 'Dismiss',
  confirmEdit: {
    ok: 'ОК',
    cancel: 'Отмена',
  },
  dataIterator: {
    noResultsText: 'Не найдено подходящих записей',
    loadingText: 'Запись загружается...',
  },
  dataTable: {
    itemsPerPageText: 'Строк на странице:',
    ariaLabel: {
      sortDescending: 'Упорядочено по убыванию.',
      sortAscending: 'Упорядочено по возрастанию.',
      sortNone: 'Не упорядочено.',
      activateNone: 'Активируйте, чтобы убрать сортировку.',
      activateDescending: 'Активируйте для упорядочивания убыванию.',
      activateAscending: 'Активируйте для упорядочивания по возрастанию.',
    },
    sortBy: 'Сортировать по',
  },
  dataFooter: {
    itemsPerPageText: 'Записей на странице:',
    itemsPerPageAll: 'Все',
    nextPage: 'Следующая страница',
    prevPage: 'Предыдущая страница',
    firstPage: 'Первая страница',
    lastPage: 'Последняя страница',
    pageText: '{0}-{1} из {2}',
  },
  dateRangeInput: {
    divider: 'до',
  },
  datePicker: {
    itemsSelected: '{0} выбрано',
    range: {
      title: 'Выбранные даты',
      header: 'Ввод дат',
    },
    title: 'Выбор даты',
    header: 'Ввод даты',
    input: {
      placeholder: 'Введите дату',
    },
  },
  noDataText: 'Отсутствуют данные',
  carousel: {
    prev: 'Предыдущий слайд',
    next: 'Следующий слайд',
    ariaLabel: {
      delimiter: 'Слайд {0} из {1}',
    },
  },
  calendar: {
    moreEvents: 'Еще {0}',
    today: 'Today',
  },
  input: {
    clear: 'Очистить {0}',
    prependAction: '{0} предварительных действий',
    appendAction: '{0} добавочных действий',
    otp: 'Пожалуйста введите символы OTP {0}',
  },
  fileInput: {
    counter: 'Файлов: {0}',
    counterSize: 'Файлов: {0} (всего {1})',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Select Time',
  },
  pagination: {
    ariaLabel: {
      root: 'Навигация по страницам',
      next: 'Следующая страница',
      previous: 'Предыдущая страница',
      page: 'Перейти на страницу {0}',
      currentPage: 'Текущая страница, Страница {0}',
      first: 'Первая страница',
      last: 'Последняя страница',
    },
  },
  stepper: {
    next: 'Следующий',
    prev: 'Предыдущий',
  },
  rating: {
    ariaLabel: {
      item: 'Рейтинг {0} из {1}',
    },
  },
  loading: 'Загрузка...',
  infiniteScroll: {
    loadMore: 'Загрузить ещё',
    empty: 'Больше нечего загружать',
  },
}
